export function debounce(func, delay) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}

export const formatDateToLocal = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const formatPrice = (price) => {
    const formattedPrice = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0
    }).format(price);

    return formattedPrice.replace('Rp', 'Rp. ');
};

export const formatTax = (tax) => {
    const formattedTax = new Intl.NumberFormat('id-ID', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }).format(tax);

    return formattedTax.replace(',', '.');
}

// Function to determine if a color is dark
export const isColorDark = (color) => {
    // Remove the `#` if it exists
    color = color.replace('#', '');

    // Convert to RGB
    const r = parseInt(color.substr(0, 2), 16);
    const g = parseInt(color.substr(2, 2), 16);
    const b = parseInt(color.substr(4, 2), 16);

    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // If luminance is less than 0.5, the color is considered dark
    return luminance < 0.5;
};


// First letter to uppercase
export const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};

export const getRandomNum = (arr) => arr[Math.floor(Math.random() * arr.length)];

export const getContrastColor = (hexColor) => {
    if (!hexColor) return "#000000"; // Default warna hitam jika tidak ada warna
  
    // Hapus "#" jika ada
    const color = hexColor.replace("#", "");
  
    // Konversi Hex ke RGB
    const r = parseInt(color.substring(0, 2), 16);
    const g = parseInt(color.substring(2, 4), 16);
    const b = parseInt(color.substring(4, 6), 16);
  
    // Hitung brightness (luminance)
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  
    // Jika brightness di atas 128, gunakan teks hitam, jika tidak gunakan teks putih
    return brightness > 128 ? "#000000" : "#ffffff";
  };

  // Fungsi untuk memformat angka dengan pemisah ribuan (untuk tampilan)
export const formatNumber = (number) => {
  return new Intl.NumberFormat("id-ID").format(number); // Format sesuai dengan format Indonesia
};

// Fungsi untuk menghapus pemisah ribuan dan mengembalikan angka murni (untuk dikirim ke API)
export const unformatNumber = (formattedNumber) => {
  return formattedNumber.replace(/\./g, ""); // Hapus titik (pemisah ribuan)
};
